<template>
  <base-layout-card
    :is-active="isActive"
    :layout="layout"
    :menu-options="menuOptions"
    :can-select-on-click="!isActive"
    :show-bookmark-button="true"
    :show-menu-button="true"
    :show-warning="showWarning"
    @select="$emit('select', $event)"
    @bookmark="$emit('bookmark', $event)"
    @reset="$emit('reset', $event)"
    @delete="$emit('delete', $event)"
  />
</template>

<script lang="ts">
import _ from 'lodash';
import {
  defineComponent,
  PropType,
  toRefs,
  computed,
  getCurrentInstance,
} from 'vue-demi';

import {
  BaseLayoutCard,
  areLayoutsEqual,
} from '@/modules/common-layout-builder';
import { Layout } from '@/types';
import { LayoutMenuAction } from '@/constants';

export default defineComponent({
  name: 'LayoutPickerCard',
  components: { BaseLayoutCard },
  props: {
    layout: {
      type: Object as PropType<Layout>,
      default: () => new Object(),
    },
    defaultLayout: {
      type: Object as PropType<Layout>,
      default: () => new Object(),
    },
    isActive: Boolean,
    showWarning: Boolean,
  },
  emits: ['select', 'bookmark', 'reset', 'delete'],
  setup(props) {
    const { isActive, layout, defaultLayout } = toRefs(props);
    const vm = getCurrentInstance()!;

    const isResetDisabled = computed(() => {
      return _.isEmpty(defaultLayout.value) || areLayoutsEqual(layout.value, defaultLayout.value);
    });

    const menuOptions = computed(() => {
      const options = [
        {
          value: LayoutMenuAction.SELECT,
          label: vm.proxy.$t('HITL.common.actions.select') as string,
          isDisabled: isActive.value,
        },
        {
          value: LayoutMenuAction.BOOKMARK,
          label: layout.value.bookmarkedAt
            ? vm.proxy.$t('HITL.ui-customization.layout-card.actions.bookmark-tooltip-remove') as string
            : vm.proxy.$t('HITL.ui-customization.layout-card.actions.bookmark-tooltip-add') as string,
        },
        {
          value: LayoutMenuAction.RESET,
          label: vm.proxy.$t('HITL.common.actions.reset') as string,
          isDisabled: isResetDisabled.value,
        },
        {
          value: LayoutMenuAction.DELETE,
          label: vm.proxy.$t('HITL.common.actions.delete') as string,
          isDisabled: isActive.value,
        },
      ];

      const actionToExclude = layout.value.madeByAgent
        ? LayoutMenuAction.RESET
        : LayoutMenuAction.DELETE;
      return options.filter(option => option.value !== actionToExclude);
    });

    return { menuOptions };
  },
});
</script>
